/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  HeadingDesc,
  HeadingDescVsmall,
  HeadingWithSpaceLarge
} from '../../../Components/Headings';
import CustomSelect2 from '../../../Components/customSelect2/CustomSelect2';
import HealthCheckLayout from '../healthCheckLayout/HealthCheckLayout';
import {
  AncerWithUnderlineSmall,
  SimpleAncerSmall
} from '../../../Components/button';
import { DateInputs, UploadInput } from '../../../Components/inputs';
import pdfIcon from '../../../assets/images/png/pdf.png';
import jpgIcon from '../../../assets/images/png/jpg-icon.png';
import arrowRight from '../../../assets/images/svg/right-arrow-border.svg';
import closeIcon from '../../../assets/images/png/close-table.png';
import backIcon from '../../../assets/images/svg/left-arrow-with-border.svg';
import './addEditMedicalRecords.css';

const profileName = [
  { value: 'alyna butt', label: 'Alyna Butt' },
  { value: 'faizan desai', label: 'Faizan Desai' }
];

const reportType = [
  { value: 'prescription', label: 'Prescription' },
  { value: 'vaccine', label: 'Vaccine' }
];

function AddEditMedicalRecords() {
  const [pictures, setPictures] = useState([
    {
      data: [],
      url: ''
    }
  ]);

  const changeHandler = (e) => {
    [...e.target.files].forEach((file) => {
      setPictures([
        ...pictures,
        {
          data: file,
          url: URL.createObjectURL(file)
        }
      ]);
    });
  };

  return (
    <HealthCheckLayout>
      <section className="addEditMedicalRecords bgLinghtGray">
        <Container>
          <div className="addBox">
            <Link to="/medicalRecordes">
              <img src={backIcon} alt="backIcon" />
            </Link>
            <HeadingWithSpaceLarge text="ADD MEDICAL RECORD" />
          </div>
          <form>
            <div className="innerBox">
              <Row>
                <Col md={8}>
                  <Row>
                    <Col md={6}>
                      <HeadingDescVsmall text="Test taken on (Date)*" />
                      <DateInputs />
                      <HeadingDescVsmall text="Select Report File Type" />
                      <CustomSelect2
                        options={reportType}
                        defaultValue={reportType[0]}
                      />
                    </Col>
                    <Col md={6}>
                      <HeadingDescVsmall text="Enter the profile for the reports*" />
                      <CustomSelect2
                        options={profileName}
                        defaultValue={profileName[0]}
                      />
                      <UploadInput onChange={changeHandler} />
                    </Col>
                    <Col md={12}>
                      <SimpleAncerSmall to="/" text="confirm" />
                    </Col>
                  </Row>
                </Col>
                <Col md={4}>
                  <div className="pdfArea">
                    <HeadingDesc text="Uploaded Reports" />
                    <div className="pdfContainer">
                      {/* {pictures?.map((pic) => (
                      <img src={pic.url} alt="pdf" />
                    ))} */}
                      <div className="pdfBox">
                        <button type="button" className="closeIcon">
                          <img src={closeIcon} alt="closeIcon" />
                        </button>
                        <img src={pdfIcon} alt="pdf" className="pdfImage" />
                        <div className="btnBox">
                          <img src={arrowRight} alt="arrowRight" />
                          <AncerWithUnderlineSmall text="view" />
                        </div>
                      </div>
                      <div className="pdfBox">
                        <button type="button" className="closeIcon">
                          <img src={closeIcon} alt="closeIcon" />
                        </button>
                        <img src={pdfIcon} alt="pdf" className="pdfImage" />
                        <div className="btnBox">
                          <img src={arrowRight} alt="arrowRight" />
                          <AncerWithUnderlineSmall text="view" />
                        </div>
                      </div>
                      <div className="pdfBox">
                        <button type="button" className="closeIcon">
                          <img src={closeIcon} alt="closeIcon" />
                        </button>
                        <img src={jpgIcon} alt="pdf" className="pdfImage" />
                        <div className="btnBox">
                          <img src={arrowRight} alt="arrowRight" />
                          <AncerWithUnderlineSmall text="view" />
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </form>
        </Container>
      </section>
    </HealthCheckLayout>
  );
}

export default AddEditMedicalRecords;
